import { motion } from 'framer-motion';
import styles from './VarImg.module.css';

export const VarImg = ({ item, varNumFontSize, currentState }) => {
  let isCorrect = currentState === 'S2' && item.correct;

  return (
    <motion.div
      initial={{ scale: 1, borderColor: '#3ab5f9' }}
      animate={{
        scale: isCorrect ? 1.05 : 1,
        borderColor: isCorrect ? '#DE1B00' : '#3ab5f9',
      }}
      transition={{ scale: { duration: 0.6 }, borderColor: { duration: 0.8 } }}
      className={`${styles.itemWrapper} ${isCorrect ? styles.isCorrect : ''}`}>
      <div className={styles.imgWrapper}>
        <motion.div
          initial={{ color: 'white' }}
          className={`${styles.varNum} ${isCorrect ? styles.isCorrect : ''}`}
          style={{
            fontSize: `${varNumFontSize}rem`,
            lineHeight: `${varNumFontSize}rem`,
          }}>
          {item.varnum}
        </motion.div>
        <img src={item.varImgUrl} />
      </div>

      <motion.div className={styles.text}>{item.comment}</motion.div>
    </motion.div>
  );
};
